<template lang="pug">
  m-table(
    store-name="adminorganizationusers"
    :headers="headers"
    :query-filter="queryFilter"
  )
</template>

<script>
import OrganizationUsers from '~/modules/organizations/models/OrganizationUsers'
import MTable from '~/components/modules/tables/m-table'
import { organizationUsersStatuses } from '~/modules/organizations/constants/common'

export default {
  name: 'BlockAdminUsers',
  components: { MTable },
  props: {
    entityId: {
      type: String,
      default: null
    },
    filterName: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'First name',
          component: 'e-two-values-table-column-text',
          componentProps: {
            firstValuePath: 'user.name',
            secondValuePath: 'user.email'
          },
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization',
          component: 'e-two-values-table-column-text',
          componentProps: {
            firstValuePath: 'organization.name',
            secondValuePath: 'organization.edrpou',
            secondValuePrependText: this.$t('EDRPOU') + ': '
          },
          sortable: false,
          filterable: false
        },
        {
          text: 'Role',
          valueFormatter: organizationUser =>
            this._.get(
              this._.find(
                OrganizationUsers.userRolesReadOnly,
                item => item.value === organizationUser.role
              ),
              'text'
            ),
          sortable: false,
          filterable: false
        },
        {
          text: 'Status',
          value: 'status',
          component: 'e-status-chip',
          componentProps: {
            statuses: organizationUsersStatuses
          },
          sortable: false,
          filterable: false
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
          width: '120',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        [this.filterName]: this.entityId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
